export default __webpack_public_path__ + "static/media/img7.3fc48676.jpg";